export default __webpack_public_path__ + "static/media/ShoppingCart.36c5afed.jpg";